import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateCw = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6892_22224)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M15.833 2.66699V6.66699H11.833",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.1602 9.99968C13.7269 11.2263 12.9066 12.2788 11.823 12.9987C10.7394 13.7185 9.45122 14.0667 8.15253 13.9907C6.85383 13.9148 5.61502 13.4188 4.62275 12.5775C3.63048 11.7362 2.93853 10.5952 2.65116 9.32639C2.36378 8.05761 2.49656 6.72981 3.02949 5.54306C3.56241 4.35632 4.4666 3.37493 5.60581 2.74678C6.74503 2.11863 8.05753 1.87775 9.34555 2.06045C10.6336 2.24314 11.8273 2.83951 12.7469 3.75968L15.8336 6.66635",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6892_22224",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgRotateCw;
